import { useTranslation } from 'react-i18next'
import { useMatch } from 'react-router'

import { ROUTE_PATH } from 'lib/paths'
import { CALL_TIMELINE_TYPE } from 'features/CallTimeline/CallTimeline'
import { useNavigate } from 'features/i18n/router'
import usePageModal from 'features/Modal/hooks/usePageModal'
import { snowplowEvent } from 'lib/analytics'

import { MODAL_MODE } from 'components/Modal/config'

const CallListShowMore = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { generatePageModalUrl } = usePageModal()

  const isTimelinePublicPage = Boolean(useMatch(ROUTE_PATH.TIMELINE_PUBLIC))

  const to = generatePageModalUrl(MODAL_MODE.CALL_LIST_MODAL, {
    callTimelineMode: isTimelinePublicPage
      ? CALL_TIMELINE_TYPE.all
      : CALL_TIMELINE_TYPE.follower,
  })

  return (
    <div
      className="Call"
      onClick={() => {
        snowplowEvent.open_call_list()
        navigate(to)
      }}
    >
      <div className="Call__avatar">
        <div className="Avatar__wrapper Call__avatar__showmore">
          <svg
            width="40"
            height="10"
            viewBox="0 0 40 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 0.777344C22.3692 0.777344 24.2898 2.66797 24.2898 5.00017C24.2898 7.33237 22.3692 9.223 20 9.223C17.6307 9.223 15.7101 7.33237 15.7101 5.00017C15.7101 2.66797 17.6307 0.777344 20 0.777344ZM35.0145 0.777344C37.3837 0.777344 39.3043 2.66797 39.3043 5.00017C39.3043 7.33237 37.3837 9.223 35.0145 9.223C32.6452 9.223 30.7246 7.33237 30.7246 5.00017C30.7246 2.66797 32.6452 0.777344 35.0145 0.777344ZM4.98547 0.777344C7.3547 0.777344 9.27533 2.66797 9.27533 5.00017C9.27533 7.33237 7.3547 9.223 4.98547 9.223C2.61625 9.223 0.695618 7.33237 0.695618 5.00017C0.695618 2.66797 2.61625 0.777344 4.98547 0.777344Z"
              fill="var(--c-secondary)"
            />
          </svg>
        </div>
      </div>

      <span className="Call__title">{t('common.show_more')}</span>
    </div>
  )
}

export default CallListShowMore
